import React, { Component } from 'react'
import { GenerateLink } from 'scripts/helpers/AppHelper'
import locale, {getLang} from 'shared/i18n/react'
import { actions } from 'scripts/store'
import CcpaLink from 'scripts/lib/Ccpa/CcpaLink'
import CookieSettingsLink from 'scripts/lib/Gdpr/CookieSettingsLink'
import { isCcpaEligible } from 'scripts/helpers/CcpaHelper'
import { GdprHelper } from '@viki-ui/gdpr'

const customOnClick = () => {
  actions.setSection('footer')
}

function mapLinks(item, index) {
  let link = null

  switch (item.type) {
    case 'page':
      link = <GenerateLink {...item} customOnClick={customOnClick} />
      break
    case 'component':
      const Component = item.component
      link = <Component>{item.title}</Component>
      break
    default:
      link = <a {...item}>{item.title}</a>
      break
  }

  return (
    <li className="footer-list-item" key={item.key || index}>{link}</li>
  )
}

class Footer extends Component {
  constructor(props) {
    super(props)
    this.lang = getLang()
    const {footer} = locale

    this.links = [
      { key: 'about', type: 'page', slug: 'about', title: footer.links.about, element: footer.links.about },
      { key: 'terms', type: 'page', slug: 'terms', title: footer.links.terms, element: footer.links.terms },
      { key: 'privacy', type: 'page', slug: 'privacy', title: footer.links.privacy, element: footer.links.privacy },
      { key: 'cookies', type: 'page', slug: 'cookies', title: footer.links.cookie, element: footer.links.cookie },
      { key: 'copyright', type: 'page', slug: 'copyright', title: footer.links.copyright, element: footer.links.copyright },
      { key: 'ad-info', href: 'https://share.hsforms.com/12cKwNC7mQPCN9DJNP49A9Qnpx', title: footer.links.adInfo, target: '_blank', rel: 'noreferrer' },
      { key: 'soompi-community-guidelines', type: 'page', slug: 'soompi-community-guidelines', title: footer.links.guide, element: footer.links.guide },
      ...(this.isCcpaEligible() ? [{ key: 'ccpa-link', type: 'component', component: CcpaLink, title: footer.links.ccpa }] : []),
      ...(this.isCookieSettingsEligible() ? [{ key: 'cookie-settings-link', type: 'component', component: CookieSettingsLink, title: footer.links.cookieSettings }] : []),
      { key: 'support-page', href: 'https://support.soompi.com/', title: footer.links.help, target: '_blank' },
      { key: 'jobs', type: 'page', slug: 'jobs', title: footer.links.jobs, element: footer.links.jobs }
    ]

    this.follow = {
      en: [
        { href: 'https://www.facebook.com/soompi', title: 'Facebook', target: '_blank' },
        { href: 'https://twitter.com/soompi', title: 'Twitter', target: '_blank' },
        { href: 'https://www.youtube.com/user/soompi', title: 'YouTube', target: '_blank' },
        { href: 'https://www.instagram.com/soompi', title: 'Instagram', target: '_blank' },
        { href: 'https://soompi.tumblr.com', title: 'Tumblr', target: '_blank' },
        { href: 'https://plus.google.com/+SoompiKpop', title: 'Google+', target: '_blank' }
      ],
      es: [
        { href: 'https://www.facebook.com/soompispanish', title: 'Facebook', target: '_blank' },
        { href: 'https://twitter.com/soompispanish', title: 'Twitter', target: '_blank' },
        { href: 'https://www.youtube.com/user/soompi', title: 'YouTube', target: '_blank' },
        { href: 'https://www.instagram.com/soompispanish', title: 'Instagram', target: '_blank' },
        { href: 'https://soompi.tumblr.com', title: 'Tumblr', target: '_blank' },
        { href: 'https://plus.google.com/+SoompiKpop', title: 'Google+', target: '_blank' }
      ]
    }
    this.date = new Date()
  }

  isCookieSettingsEligible = () => {
    const {ssr} = this.props

    // Don't render on server side to avoid cross country static content being cached
    if (ssr) {
      return false
    }

    let Country = 'xx'
    if (window && window.esiParams) {
      Country = window.esiParams.cc || Country
    }

    return GdprHelper.isEuCountry(Country.toLowerCase())
  }

  isCcpaEligible = () => {
    const {ssr} = this.props

    // Don't render on server side to avoid cross country static content being cached
    return !ssr && isCcpaEligible()
  }

  renderSiteMap = () => {
    const {ssr} = this.props

    if (ssr) {
      return null
    }

    return this.links.map(mapLinks)
  }

  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col small-12 med-4">
              <div className="columnize-links columnize-links-wrapper-small">
                <h3 className="header muted-light uppercase">{locale.footer.follow}</h3>
                <ul>{this.follow[this.lang].map(mapLinks)}</ul>
              </div>
            </div>
            <div className="col small-12 med-4">
              <div className="columnize-links columnize-links-wrapper-med">
                <h3 className="header muted-light uppercase">{locale.footer.sitemap}</h3>
                <ul>{this.renderSiteMap()}</ul>
              </div>
            </div>
            <div className="col small-12 med-4 footer-language">
              <div className="columnize-links columnize-links-wrapper-med">
                <h3 className="header muted-light uppercase">{locale.footer.language}</h3>
                <div className="contrast strong footer-language">
                  <a href="/" className={`${this.lang === 'en' ? 'active' : ''}`}>{locale.footer.english}</a>
                  <span className="vertical-separator"/>
                  <a href="/es" className={`${this.lang === 'es' ? 'active' : ''}`}>{locale.footer.spanish}</a>
                </div>
              </div>
            </div>
          </div>
          <div className="copyright">
            <div>&copy; 1998 &ndash; {this.date.getFullYear()} Viki Inc.</div>
            <div>{locale.formatString(locale.footer.family, <a href="https://www.viki.com" target="_blank">Rakuten Viki</a>)}</div>
          </div>
        </div>
      </div>
    )
  }
}

export default Footer



// WEBPACK FOOTER //
// ./assets/js/components/static/footer.jsx